module.exports = __webpack_public_path__ + "img/add-s-1.63a66bad.png";